/** @jsx jsx */
import { jsx } from '@compiled/react';
import { CommentAction } from '@atlaskit/comment';
import { useIntl } from '@atlassian/jira-intl';
import messages from '../messages.tsx';
import { useCommentContext } from './CommentContextProvider.tsx';
import { useReply } from './utils.tsx';

const ReplyAction = () => {
	const { canAdd, isThreadedCommentsEnabled, isSaving } = useCommentContext();
	const onReply = useReply();
	const { formatMessage } = useIntl();
	if (!canAdd || !isThreadedCommentsEnabled) {
		return null;
	}
	return (
		<CommentAction isDisabled={isSaving} key="reply" onClick={() => onReply()}>
			{formatMessage(messages.reply)}
		</CommentAction>
	);
};
export default ReplyAction;
